// rollover
var preLoadImg = new Object();
 
function initRollOvers(){
  $("img.imgover,input.imgover").each(function(){
    var imgSrc = this.src;
    var sep = imgSrc.lastIndexOf('.');
    var onSrc = imgSrc.substr(0, sep) + '_o' + imgSrc.substr(sep, 4);
    preLoadImg[imgSrc] = new Image();
    preLoadImg[imgSrc].src = onSrc;
    $(this).hover(
      function() { this.src = onSrc; },
      function() { this.src = imgSrc; }
    );
  });
}
$(function(){
  initRollOvers();
});


// smoothScroll
var targetIdHold = jQuery(this.hash);

jQuery.easing.quart = function (x, t, b, c, d) {
  return -c * ((t = t / d - 1) * t * t * t - 1) + b;
};

jQuery(document).ready(function () {
  jQuery('a[href*="#"]').click(function () {
    let targetId = jQuery(this.hash);
    let scroll = $(window).scrollTop();

    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      let target = jQuery(this.hash);
      target = target.length && target || jQuery('[name=' + this.hash.slice(1) + ']');
      let headerH = $('#header').innerHeight();
      let adjust = 0; // ターゲット先へスクロール移動

      if (target.length) {
        let targetOffset = target.offset().top - headerH - adjust;

        jQuery('html,body').animate({
          scrollTop: targetOffset
        }, 1200, 'swing');

        return false;
      }
    }
  });
});

// 他ページからのsmoothScroll
$(function () {
  let hash = location.hash;
  let headerH = $('#header').innerHeight();

	if (hash){
		$("html, body").stop().scrollTop(0);

		setTimeout(function(){
			let target = $(hash),
			position = target.offset().top - headerH;

			$("html, body").animate({scrollTop:position}, 1200, "swing");
		});
	}
});


// slide btn
$(function(){
  $(".js-slideBtn").each(function(index,element) {
    $(element).click(function() {
      $(this).toggleClass('is-active');
      $(element).next(".js-slidePanel").slideToggle(300);
    });
  });

  // ハッシュがあるときはオープン
  if (window.location.hash.length>0) {
    if ($(window.location.hash).next(".js-slideBox").find(".js-slideBtn").hasClass('is-active')) {
    } else {
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").toggleClass('is-active');
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").next(".js-slidePanel").slideToggle(300);
    }
  }
});


// service menu
$(function() {
  // メニュー開閉
  $("#js-servicemenu").click(function() {
    if ($(this).hasClass('is-open')) {
      servicemenuChange("close");
    } else {
      servicemenuChange("open");
    }
  });
  
  // メニュー選択(クリック)時
  $("#servicemenu").find('a').click(function() {
    servicemenuChange("close");
  });
});


function servicemenuChange(state) {
  let servicemenuTxtJp = "";
  let servicemenuTxtEn = "";

  if (state == "open") {
    $("#js-servicemenu").removeClass('is-close');
    $("#servicemenu").removeClass('is-close');

    $("#js-servicemenu").addClass('is-open');
    $("#servicemenu").addClass('is-open');

    servicemenuTxtJp = $('#js-servicemenu').data('isopentxtjp');
    servicemenuTxtEn = $('#js-servicemenu').data('isopentxten');

    $("#js-servicemenu_txt_jp").text(servicemenuTxtJp);
    $("#js-servicemenu_txt_en").text(servicemenuTxtEn);
  } else {
    $("#js-servicemenu").removeClass('is-open');
    $("#servicemenu").removeClass('is-open');

    $("#js-servicemenu").addClass('is-close');
    $("#servicemenu").addClass('is-close');

    servicemenuTxtJp = $('#js-servicemenu').data('isclosetxtjp');
    servicemenuTxtEn = $('#js-servicemenu').data('isclosetxten');

    $("#js-servicemenu_txt_jp").text(servicemenuTxtJp);
    $("#js-servicemenu_txt_en").text(servicemenuTxtEn);
  }
}


// header scroll settings
$(window).on('load scroll resize', function(){
  var headerPosTop = 30;  //ヘッダーの初期位置
  
  var winW = $(window).width();
  var winIW = window.innerWidth;  /* スクロールバーを含む幅 */
  var hd = $('#header');
  var contentTop = $('#hero');
  var gnav = $('#gnavfix');
  var logo = $('#js-hdlogo');
  var gnavBtns = $('#ganvBtn');
  var scroll = $(window).scrollTop();

  if ( scroll == 0 && winIW < 850 ) {
    hd.removeClass('js-isscroll');
    hd.addClass('js-noscroll');
  } else if( scroll < headerPosTop && winIW >= 850 ) {
    hd.removeClass('js-isscroll');
    hd.addClass('js-noscroll');
  } else if ( winIW >= 850 ) {
    hd.removeClass('js-noscroll');
    hd.addClass('js-isscroll');
  } else {
    hd.removeClass('js-noscroll');
    hd.addClass('js-isscroll');
  }
});


// バーガーメニュー開閉
$(function(){
  $("#js-drawerOpen").click(function() {
    if ($("#js-drawerOpen").hasClass('is-open')) {
      $("#js-drawerOpen").removeClass('is-open');
      $("#drawer").removeClass('is-open');
      $("#gnav").removeClass('is-open');
      $("#js-drawerOpen").addClass('is-close');
      $("#drawer").addClass('is-close');
      $("#gnav").addClass('is-close');
    } else {
      $("#js-drawerOpen").removeClass('is-close');
      $("#drawer").removeClass('is-close');
      $("#gnav").removeClass('is-close');
      $("#js-drawerOpen").addClass('is-open');
      $("#drawer").addClass('is-open');
      $("#gnav").addClass('is-open');
    }
  });
});

$(window).on('resize', function(){
  let winIW = window.innerWidth;

  //ブラウザ幅850px以上時は、ドロワーはis-open、is-closeクラスを削除する
  if ( winIW >= 850 ) {
    $("#js-drawerOpen").removeClass('is-open');
    $("#drawer").removeClass('is-open');
    $("#gnav").removeClass('is-open');
    $("#js-drawerOpen").removeClass('is-close');
    $("#drawer").removeClass('is-close');
    $("#gnav").removeClass('is-close');
  }
});

//メニュークリック
$(function(){
  $(".js-gnavItem").each(function(index,element) {
    $(element).click(function() {
      if ( $("#js-drawerOpen").hasClass('is-open') ) {
        $("#js-drawerOpen").removeClass('is-open');
        $("#drawer").removeClass('is-open');
        $("#gnav").removeClass('is-open');
      }
    });
  });

  // ハッシュがあるときはオープン
  if (window.location.hash.length>0) {
    if ($(window.location.hash).next(".js-slideBox").find(".js-slideBtn").hasClass('is-active')) {
    } else {
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").toggleClass('is-active');
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").next(".js-slidePanel").slideToggle(300);
    }
  }
});


$(window).on('load scroll resize', function(){  
  let winW    = $(window).width();
  let winIW = window.innerWidth;        //スクロールバーを含む幅 
  let winH    = $(window).height();  //ウィンドウの高さ
  let scroll  = $(window).scrollTop();
  let fadeinitem  = $('.js-fadeinitem');
  let fadeinupitem  = $('.js-fadeinupitem');
  let slideupitem  = $('.js-slideupitem');
  let slideupitems  = $('.js-slideupitems');
  let bloomingitem  = $('.js-bloomingitem');
  let revealtext  = $('.js-revealtext');
  let blurwhitem  = $('.js-blurwhitem');
  let charupitem  = $('.js-charupitem');

  //要素フェードイン
  fadeinitem.each(function(){
    let fiiTop = $(this).offset().top;

    // 要素が画面の上から80%(下から20%)に来た時に動く
    let fadeinitemPos = fiiTop - (winH * 0.8);

    if (scroll > fadeinitemPos) {
      $(this).addClass("js-fadein");
    }
  });

  //要素フェードイン&アップ
  fadeinupitem.each(function(){
    let fiuiTop = $(this).offset().top;

    // 要素が画面の上から80%(下から20%)に来た時に動く
    let fadeinupitemPos = fiuiTop - (winH * 0.8);

    if (scroll > fadeinupitemPos) {
      $(this).addClass("js-fadeinup");
    }
  });

  //要素スライドアップ
  slideupitem.each(function(){
    let suiTop = $(this).offset().top;

    // 要素が画面の上から80%(下から20%)に来た時に動く
    let slideupitemPos = suiTop - (winH * 0.8);

    if (scroll > slideupitemPos) {
      $(this).addClass("js-slideup");
    }
  });

  //配下の複数要素連続スライドアップ
  slideupitems.each(function() {
    let suiTop = $(this).offset().top;

    // 要素が画面の上から80%(下から20%)に来た時に動く
    let slideupitemsPos = suiTop - (winH * 0.8);

    if (scroll > slideupitemsPos) {
      $(this).addClass("js-slideups");
    }
  });

  //要素CharUp表示
  charupitem.each(function(){
    let cuTop = $(this).offset().top;

    // 要素が画面の上から100%(下から0%)に来た時に動く
    let charupitemPos = cuTop - (winH * 1.0);

    if (scroll > charupitemPos) {
      $(this).addClass("js-charup");
    }
  });

  //要素テキスト色Blooming
  bloomingitem.each(function(){
    let bmiTop = $(this).offset().top;

    // 要素が画面の上から90%(下から10%)に来た時に動く
    let bloomingitemPos = bmiTop - (winH * 0.9);

    if (scroll > bloomingitemPos) {
      $(this).addClass("js-isblooming");
    }
  });
});



//fadein
$(window).scroll(function (){
  $('.js-fadeIn').each(function(){
    var elemPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > elemPos - windowHeight - 30){
        $(this).addClass('js-scrollIn');
    }
  });
});


// 電話番号リンク
if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
  $(function() {
    $('.js-tellink').each(function() {
      var str = $(this).html();

      if ($(this).children().is('img')) {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/[^0-9]/g, '')).append(str + '</a>')); //対象文字列内から数字だけ取り出してhrefにセット
      } else {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/[^0-9]/g, '')).append(str + '</a>')); //対象文字列内から数字だけ取り出してhrefにセット
      }
    });
  });
}
